var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['report-card', _vm.dark]},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-number",style:({ color: _vm.color })},[_vm._v(_vm._s(_vm.number))])])
}
var staticRenderFns = []

export { render, staticRenderFns }